"use client";
// A "Contact us" button that opens the inquiry form in a modal. Used on course
// pages (unpriced courses) and anywhere a contact CTA is needed.
import { useState } from "react";
import { useLocale } from "next-intl";
import { X } from "lucide-react";
import { ContactForm } from "./contact-form";
import type { InquiryType } from "@/actions/submit-inquiry";

export function ContactUsButton({
  courseSlug = null,
  courseTitle = null,
  defaultType,
  label,
  className,
}: {
  courseSlug?: string | null;
  courseTitle?: string | null;
  defaultType?: InquiryType;
  label?: string;
  className?: string;
}) {
  const locale = useLocale();
  const [open, setOpen] = useState(false);
  const text = label ?? (locale === "ar" ? "تواصل معنا" : "Contact us");

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className={className ?? "inline-flex items-center gap-2 rounded-lg border border-(--fm-primary)/40 bg-(--fm-primary)/10 px-4 py-2 font-semibold text-(--fm-primary) transition hover:bg-(--fm-primary)/20"}
      >
        {text}
      </button>
      {open && (
        <div className="fixed inset-0 z-50 grid place-items-center bg-black/60 p-4" onClick={() => setOpen(false)}>
          <div
            className="w-full max-w-md rounded-2xl border border-(--fm-border) bg-(--fm-surface) p-5 shadow-2xl"
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-modal="true"
          >
            <div className="mb-3 flex items-center justify-between">
              <h2 className="text-lg font-semibold text-(--fm-text-primary)">{locale === "ar" ? "تواصل معنا" : "Contact us"}</h2>
              <button type="button" onClick={() => setOpen(false)} aria-label={locale === "ar" ? "إغلاق" : "Close"}
                className="text-(--fm-text-secondary) hover:text-(--fm-text-primary)">
                <X className="size-5" />
              </button>
            </div>
            <ContactForm
              courseSlug={courseSlug}
              courseTitle={courseTitle}
              defaultType={defaultType}
              onDone={() => setOpen(false)}
            />
          </div>
        </div>
      )}
    </>
  );
}
